module.exports = __webpack_public_path__ + "img/result.c8eaa33b.png";